import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import lodashCompact from 'lodash/fp/compact';

import SrSimpleDropdown from 'client/components/SrSimpleDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

export const SR_USER_SETTING_LEASING_MANAGER_FILTER_BY_ALL = 'SR_USER_SETTING_LEASING_MANAGER_FILTER_BY_ALL'; // eslint-disable-line max-len

const SrUserSettingLeasingManagerDropdown = ({
  leasingOperationManagers,
  leasingOperationManagerUserId,
  onUpdate,
}) => {
  const [settingValueRaw, setSettingValueRaw] = useState(leasingOperationManagerUserId);
  useEffect(() => {
    setSettingValueRaw(leasingOperationManagerUserId);
  }, [leasingOperationManagerUserId]);

  const settingValue = Array.isArray(settingValueRaw) ? settingValueRaw : [settingValueRaw];

  const onChange = (leasingOperationManagerUserId) => {
    if (leasingOperationManagerUserId === SR_USER_SETTING_LEASING_MANAGER_FILTER_BY_ALL) {
      setSettingValueRaw(leasingOperationManagerUserId);
    }
    else if (settingValueRaw === SR_USER_SETTING_LEASING_MANAGER_FILTER_BY_ALL) {
      setSettingValueRaw([leasingOperationManagerUserId]);
    }
    else if (leasingOperationManagerUserId) {
      const newSettingValue = settingValue.includes(leasingOperationManagerUserId)
        ? settingValue.filter((id) => id !== leasingOperationManagerUserId)
        : [...settingValue, leasingOperationManagerUserId];

      setSettingValueRaw(lodashCompact(newSettingValue));
    }
    else {
      setSettingValueRaw(undefined);
    }
  };

  const onSave = () => {
    onUpdate(settingValueRaw);
  };

  const options = [
    {
      label: 'all',
      value: SR_USER_SETTING_LEASING_MANAGER_FILTER_BY_ALL,
    },
    ...(leasingOperationManagers).map((option) => ({
      label: option.name,
      value: option.id,
    })),
  ];

  const optionsActive = options
    .filter((option) => settingValue.includes(option.value))
    .map(({ label }) => label)
    .join(',');

  return (
    <SrSimpleDropdown
      title={`Leasing Manager : ${optionsActive || 'all'}`}
      options={options.map((option) => ({
        id: option.value,
        title: option.label,
        isActive: settingValue.includes(option.value),
      }))}
      onChange={onChange}
      multiple
      footer={(
        <div className='buttonContainer'>
          <ButtonDeprecated
            theme={BUTTON_THEME_BLUE}
            type='button'
            onClick={onSave}
          >
            save
          </ButtonDeprecated>
        </div>
      )}
    />
  );
};

SrUserSettingLeasingManagerDropdown.propTypes = {
  leasingOperationManagers: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

SrUserSettingLeasingManagerDropdown.displayName = 'SrUserSettingLeasingManagerDropdown';

export default SrUserSettingLeasingManagerDropdown;
